import { render, staticRenderFns } from "./GalleryAddPopup.vue?vue&type=template&id=608475d7&"
import script from "./GalleryAddPopup.vue?vue&type=script&lang=js&"
export * from "./GalleryAddPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports